import React from "react";
import { io } from "socket.io-client";

const { NODE_ENV } = process.env;
const isDevelopmentMode = NODE_ENV === "development";

export const socket = io();

export const connectUser = (userId) => {
  if (!userId) return;
  socket.emit("userConnected", { userId }, () => {
    console.log(`user ${userId} connected to socket`);
  });
};

if (isDevelopmentMode) {
  socket.on("connect", () => {
    console.log("Socket Connected to server successfully!");
  });

  socket.on("connect_error", (error) => {
    console.error("Socket Connection error:", error);
  });

  socket.on("error", (error) => {
    console.error("Socket error:", error);
  });

  socket.on("disconnect", (reason) => {
    console.log("Socket Disconnected from server:", reason);
  });

  socket.emit("handshake", "ping", (response) => {
    console.log("Sent to server:", "ping");
    console.log("Response from the server:", response);
  });
}

export const SocketContext = React.createContext();
